export const shopifyOptionAttributes = ["barcode", "on_hand", "available"];

export const availableOptions = ["size", "color", "material", "style"];

export const maxOptionsLimit = 3;

export const maxOptionValues = 5;
